import { render, staticRenderFns } from "./IDBeamline.vue?vue&type=template&id=ba3608e8&scoped=true&"
import script from "./IDBeamline.vue?vue&type=script&lang=js&"
export * from "./IDBeamline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3608e8",
  null
  
)

export default component.exports